import { AllTokens } from "gql/graphql";
import { ReactNode } from "react";
import { Guard } from "@/shared/security/model/guard/guard";

/** Раздел динамических процессов: список и редактор. */
export function RestrictDynamicProcesses({
  children,
}: {
  children: ReactNode;
}) {
  return (
    <Guard.Redirect.IfCantModify.PageNotFound
      influencedBy={[AllTokens.TasksDynamicProcesses]}
    >
      {children}
    </Guard.Redirect.IfCantModify.PageNotFound>
  );
}
